import PropTypes from 'prop-types'
import React from 'react'
import PaymentItem from '@/checkout-instore-legacy/components/Commons/PaymentItem'
import { buildChildId } from '@/checkout-instore-legacy/utils/TestUtils'

export default function GiftCardsList({ id, renderActions, giftCards }) {
  return (
    <div id={id} className="GiftCardsList component">
      {giftCards.map((giftCard, index) => {
        const itemId = buildChildId(['item', index], id)
        return (
          <PaymentItem
            className="bb b--black-10"
            id={itemId}
            key={giftCard.id}
            paymentName={giftCard.caption}
            groupName="giftCardPaymentGroup"
            value={giftCard.balance}
          >
            {renderActions
              ? renderActions({ index, giftCard, parentId: itemId })
              : null}
          </PaymentItem>
        )
      })}
    </div>
  )
}

GiftCardsList.propTypes = {
  id: PropTypes.string,
  giftCards: PropTypes.array,
  renderActions: PropTypes.func,
}
